export default __webpack_public_path__ + "static/media/Pokeffective-Retro.45eb4569.jpg";